module.exports = __webpack_public_path__ + "img/malaysia.7da9df6b.svg";